import { useEffect, useState } from 'react'
import { Button } from '@/components/ui/button'
import { useSigningDocumentPdf } from './queries'

const loading = (
  <div className="flex flex-1 items-center justify-center py-8 text-sm text-muted-foreground">
    Loading document…
  </div>
)

export function StoredDocumentPreview({
  documentId,
  version,
}: {
  documentId: string
  version: string
}) {
  const pdf = useSigningDocumentPdf(documentId, version)
  if (pdf.isError)
    return (
      <div
        role="alert"
        className="flex flex-1 flex-col items-center justify-center gap-2 text-sm text-muted-foreground">
        <p>Could not load document.</p>
        <Button variant="ghost" size="sm" onClick={() => void pdf.refetch()}>
          Retry
        </Button>
      </div>
    )
  if (!pdf.data) return loading
  return <StoredPdf key={`${documentId}:${version}`} file={pdf.data} />
}

function StoredPdf({ file }: { file: Blob }) {
  const [url, setUrl] = useState<string>()
  useEffect(() => {
    const next = URL.createObjectURL(file)
    setUrl(next)
    return () => URL.revokeObjectURL(next)
  }, [file])
  if (!url) return loading
  // PandaDoc exports paint input values into page content. Preserve signed
  // originals byte-for-byte and let the browser provide PDF navigation/zoom.
  return (
    <iframe
      src={url}
      title="Document preview"
      className="min-h-0 w-full flex-1"
    />
  )
}
